import { gql } from '@apollo/client'

export default gql`
  mutation BookmarkNFT($input: SaveBookmarkInput!) {
    saveBookmarkNFT(input: $input) {
      nftType
      tokenID
      isBookmarked
    }
  }
`
